import React, { useEffect, useRef, useState } from 'react'
import Navbar from '../../componenets/Navbar'
import bgImage from '../../Images/fish2.jpeg'
import Project_img from '../../Images/fishing.jpeg'
import Project_img2 from '../../Images/c3.jpeg'
import { Link } from 'react-router-dom'
import Footer from '../../componenets/Footer'
import { FiArrowUpRight } from 'react-icons/fi'
import { BsArrowLeft, BsArrowRight } from 'react-icons/bs'
import WOW from "wowjs";
import "animate.css";



const Fishing = () => {
  
      const scrollRef = useRef(null);
    
    
      const [leftActive, setLeftActive] = useState(false);

      const scroll = (direction) => {
        const { current } = scrollRef;
      
        if (direction === "right") {
          setLeftActive(true); // left becomes active
        }
      
        if (direction === "left") {
          setLeftActive(false); // optional: left goes back to default
        }
      
        if (current) {
          const scrollAmount = 300;
          current.scrollBy({
            left: direction === "left" ? -scrollAmount : scrollAmount,
            behavior: "smooth",
          });
        }
      };


  const images = [
    Project_img, Project_img2, bgImage
  ];

  useEffect(() => {
    new WOW.WOW({
      live: false
    }).init();
  }, []);

  return (
    <div>
        <Navbar />

    <section
      className="about_who-we-are"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="about_who-we-are-content">
        <p className="about_tag">Services</p>
        <h1>Fishing Services</h1>
      </div>
    </section>

    <section className="border_bottom_div wow animate__animated animate__fadeInUp" data-wow-delay="0.3s">
        <h2>Swift retrievals. Reduced downtime. Restored operations.</h2>
    </section>

    <section className="services_detail_text wow animate__animated animate__fadeInUp" data-wow-delay="0.3s">
        <p>We provide professional fishing services to retrieve stuck, lost, or damaged equipment from wellbores, minimizing downtime and ensuring safe well restoration.</p>
        <p>Our experienced crew utilizes advanced fishing tools and proven techniques to quickly diagnose wellbore challenges and recover lost components.</p>
        <p>With a proactive problem-solving approach, we ensure efficient operations and cost-effective outcomes for our clients.</p>
        <Link to="/contact">
          <div className="contactBtn">
            <button className="contact-btn">
                Become a Client
            </button>
            <button className="contact-btn">
                <FiArrowUpRight  size={24}/>
            </button>
          </div>
        </Link>
    </section> 


    <div className="project_work wow animate__animated animate__fadeInUp" data-wow-delay="0.3s">
    <div className="project_ontrol_btn">
      <button
        className={leftActive ? "active" : ""}
        onClick={() => scroll("left")}
      >
        <BsArrowLeft />
      </button>

      <button className="active" onClick={() => scroll("right")}>
        <BsArrowRight />
      </button>
    </div>
        <div className="project_img_carrier">
           <div className="project_container" ref={scrollRef}>
            {images.map((img, index) => (
                <div className="project_work_items" key={index}>
                <img src={img} alt={`project-${index}`} />
                </div>
            ))}
           </div>
        </div>
    </div> 



    {/* <div className="carousel-wrapper">
      <div className="carousel-container" ref={scrollRef}>
        {images.map((src, i) => (
          <div className="carousel-item" key={i}>
            <img src={src} alt={`slide-${i}`} className="carousel-image" />
          </div>
        ))}
      </div>

      <div className="carousel-controls">
        <button className="arrow left" onClick={() => scroll("left")}>
          &#8592;
        </button>
        <button className="arrow right" onClick={() => scroll("right")}>
          &#8594;
        </button>
      </div>
    </div> */}



    <Footer />

    </div>
  )
}

export default Fishing